import { useQuery } from '@tanstack/react-query';
import { Endpoint } from '@/Config/api/endpoint';
import { ConversationTopicsApi } from '@/Domain/api/Conversation/ConversationTopics.api';

export const useConversationTopicsList = () => {
  const query = useQuery({
    queryKey: [`${Endpoint.conversationTopics.list}-list`],
    queryFn: () => ConversationTopicsApi.list(),
  });

  const hasFilledTopic = query.data?.some(({ topic }) => !!topic);

  return { ...query, hasFilledTopic };
};
